import * as R from 'ramda'

export const intParser = (val: string) => {
  const res = parseInt(val, 10)
  return isNaN(res) ? null : res
}

export const handleKeyDown = cb => e => {
  if (e.key === 'Enter' && e.shiftKey === false) {
    e.preventDefault()
    cb()
  }
}

/* Given an object obj, transform every string field in keys array into a float. */
export function parseFloats<T, K extends keyof T>(obj: T, keys: Array<K>): T {
  return transformFields(obj, keys, v => parseFloat((v + '').replace(',', '.')))
}

/* tslint:disable no-any */
/* Given object obj, transform all keys specified using transform function. */
export function transformFields<T, K extends keyof T>(
  obj: T,
  keys: Array<K>,
  transform: (v: any) => any
): T {
  const fields = R.pick<T, K>(keys, obj)
  const x: any = R.keys(fields).map(k => [k, transform(fields[k])])
  return R.merge(obj, R.fromPairs(x))
}
/* tslint:enable no-any */



// WEBPACK FOOTER //
// ./src/Components/Workspace/Calculation/Editors/shared.ts